import React from "react";
import { Eye, TrendingUp, TrendingDown, Minus } from "lucide-react";

// Founding Suppliers: monthly profile views vs the paid-listing average in each category.
export default function ViewInsightsPanel({ insights }) {
  if (!insights || !insights.items?.length) return null;
  return (
    <div className="mt-6 bg-white border border-[#E8ECE9] p-5" data-testid="view-insights-panel">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div>
          <div className="tracking-overline text-[10px] text-[#B8860B] flex items-center gap-1.5"><Eye className="w-3.5 h-3.5" /> Category view insights</div>
          <div className="font-serif text-lg text-[#11211A] mt-0.5">How your profile views compare — {insights.month_label}</div>
        </div>
        <div className="text-xs text-[#7D8C85]">Average = paid listings in the same category this month</div>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        {insights.items.map((it) => {
          const Icon = it.verdict === "above" ? TrendingUp : it.verdict === "below" ? TrendingDown : Minus;
          const tone = it.verdict === "above" ? "text-[#264839] bg-emerald-50 border-emerald-200" : it.verdict === "below" ? "text-[#B35C4A] bg-[#FBECE8] border-[#B35C4A]/30" : "text-[#7D8C85] bg-[#F0EFEA] border-[#E8ECE9]";
          const share = it.category_avg ? Math.min(100, Math.round((it.views_this_month / Math.max(it.category_avg, it.views_this_month, 1)) * 100)) : 100;
          return (
            <div key={it.listing_id} className="border border-[#E8ECE9] p-4" data-testid={`view-insight-${it.listing_id}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="text-sm text-[#11211A] font-medium truncate">{it.title}</div>
                  <div className="text-[11px] text-[#7D8C85]">{it.category} · {it.peer_count} paid listing{it.peer_count === 1 ? "" : "s"}</div>
                </div>
                <span className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.12em] border px-1.5 py-0.5 shrink-0 ${tone}`} data-testid={`view-insight-verdict-${it.listing_id}`}>
                  <Icon className="w-3 h-3" />
                  {it.vs_avg_pct === null ? "No comparison yet" : it.vs_avg_pct === 0 ? "On average" : `${Math.abs(it.vs_avg_pct)}% ${it.verdict} avg`}
                </span>
              </div>
              <div className="flex items-end gap-6 mt-3">
                <div>
                  <div className="font-serif text-3xl text-[#11211A] leading-none" data-testid={`view-insight-views-${it.listing_id}`}>{it.views_this_month}</div>
                  <div className="text-[10px] uppercase tracking-wider text-[#7D8C85] mt-1">your views</div>
                </div>
                <div>
                  <div className="font-serif text-3xl text-[#7D8C85] leading-none" data-testid={`view-insight-avg-${it.listing_id}`}>{it.category_avg}</div>
                  <div className="text-[10px] uppercase tracking-wider text-[#7D8C85] mt-1">category avg</div>
                </div>
                <div className="ml-auto text-right">
                  <div className="font-serif text-xl text-[#264839] leading-none">#{it.rank}</div>
                  <div className="text-[10px] uppercase tracking-wider text-[#7D8C85] mt-1">of {it.peer_count}</div>
                </div>
              </div>
              <div className="mt-3 h-1.5 bg-[#E8ECE9] relative">
                <div className="h-full bg-[#264839]" style={{ width: `${share}%` }} />
                {it.category_avg > 0 && <div className="absolute top-[-3px] h-3 w-px bg-[#B8860B]" style={{ left: `${Math.min(100, Math.round((it.category_avg / Math.max(it.category_avg, it.views_this_month, 1)) * 100))}%` }} title="Category average" />}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
